import { useEffect, useRef } from 'react';
import { useAuth } from './useAuth';
import { useWishlist } from './useWishlist';

export const useWishlistLoader = (options = {}) => {
  const { enabled = true } = options;
  const { user } = useAuth();
  const { fetchWishlist } = useWishlist();
  const hasFetchedRef = useRef(false);
  const lastUserIdRef = useRef(null);

  useEffect(() => {
    if (!enabled || !user) {
      hasFetchedRef.current = false;
      lastUserIdRef.current = null;
      return;
    }

    if (user.role !== 'customer') {
      hasFetchedRef.current = false;
      return;
    }

    if (lastUserIdRef.current !== user.id) {
      hasFetchedRef.current = false;
      lastUserIdRef.current = user.id;
    }

    if (!hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchWishlist().catch(console.error);
    }
  }, [user, user?.id, user?.role, enabled, fetchWishlist]);

  return null;
};

export default useWishlistLoader;